import React from "react";
import { Grid } from "@mui/material";
import backgroundImage from "../assets/images/backgroundImage.png";
import BeforeLoginHeader from './beforeLoginHeader'
import BeforeLoginFooter from './beforeLoginFooter'


export default function BeforeLoginLayout({ children }) {
  return (<>
    <Grid
      sx={{
        minHeight: "100vh",
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat"
      }}
    >
      <BeforeLoginHeader />
      {children}
      <BeforeLoginFooter />
    </Grid>
    
    </>
  );
}
